<template>
<div class="chapter">
<div class="inner_page">
<div id="Dedication">
<p class="Dedication"><a id="page_1">A sequel to <i>Seven Seas, Nine Lives</i> –<br/>more war experiences of<br/>Captain A W F ‘Alfie’ Sutton CBE DSC* RN</a></p><a id="page_1">
</a></div><a id="page_1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Dedication.vue?375f769c